module.exports = __webpack_public_path__ + "media/registration/us-citizen-icon-f077cb20.svg";